<script setup>
  import { useTemplateVariablesStore } from '../../stores/TemplateVariablesStore'
  import { ref, onMounted } from 'vue'

  const emit = defineEmits(['back'])
  const templateStore = useTemplateVariablesStore()
  const { getDefinitionById } = templateStore
  const howDoesRenewalWorkContent = ref('')

  const backToRenewalMain = () => {
    emit('back')
  }

  // Add event listener to dynamic back button after content is loaded
  const addBackButtonListener = () => {
    setTimeout(() => {
      const backButtons = document.querySelectorAll('.back-button')
      backButtons.forEach(button => {
        // Remove any existing listeners to prevent duplicates
        button.removeEventListener('click', backToRenewalMain)
        // Add new listener
        button.addEventListener('click', backToRenewalMain)
      })
    }, 100) // Small delay to ensure DOM is updated
  }

  // Add listeners when component is mounted
  onMounted(async () => {
    let text = await getDefinitionById('howDoesRenewalWorkContent', '', '', '', false)
    howDoesRenewalWorkContent.value = text.body
    addBackButtonListener()
  })
</script>

<template>
  <div class="renewal-help-guide px-4" v-html="howDoesRenewalWorkContent" />
</template>

<style scoped>
.renewal-help-guide {
  padding: 1rem;
  text-align: left;
}
</style>
